import { getCategoriesStats } from './getCategoriesStats.js';
/**
 * Get class numbers for each metadata entry
 * @param metadata - Array of metadata objects
 * @param options - Options for classification
 * @returns Array of class numbers
 */
export function getClasses(metadata, options = {}) {
    const { propertyName = 'category' } = options;
    const categoriesStats = getCategoriesStats(metadata, options);
    const result = new Array(metadata.length);
    for (let i = 0; i < metadata.length; i++) {
        result[i] = categoriesStats[metadata[i][propertyName]].classNumber;
    }
    return result;
}
//# sourceMappingURL=getClasses.js.map